export default function () {
  return {
    pronostico: null,   
    evento: null,   
    competidores: null,   
    deporte: null,   
  };
}
